import {observer} from "mobx-react";
import {Outlet, useNavigate} from "react-router-dom";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import { useEffect } from "react";
import currentPortalStore from "../../stores/current-portal-store";
import uiSettingsStore from "../../stores/ui-settings-store";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";

const ManageReturnsPage: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
	useEffect(() => {
        currentPortalStore.load();
        uiSettingsStore.load();
    }, []);

    const navigate = useNavigate();

    const onBackButtonClick = () => {
        navigate('/manage-returns/rma-list-page');
    }

	return (
		<BasePageLayout title={getTranslation('MANAGE_RETURNS', 'dashboard-returns-page')} backButtonCallback={onBackButtonClick}>
			<Outlet />
		</BasePageLayout>
	)
});

export default ManageReturnsPage;